import { useState, useEffect } from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import Chemicals from "layouts/setup/components/Chemicals";
import Employees from "layouts/setup/components/Employees";
import Sprayers from "layouts/setup/components/Sprayers";
import Orchards from "layouts/setup/components/Orchards";
import StockLocations from "layouts/setup/components/StockLocations";

import { db } from "firebaseDb";
import { getDocs, collection, query, orderBy } from "firebase/firestore";
import { CircularProgress } from "@mui/material";

function Setup() {
  const [activeTab, setActiveTab] = useState(0);
  const [chemicals, setChemicals] = useState([]);
  const [orchards, setOrchards] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [sprayers, setSprayers] = useState([]);
  const [varieties, setVarieties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const chemRef = collection(db, "Chemicals");
    const q = query(chemRef, orderBy("chemicalName", "asc"));
    getDocs(q).then((querySnapshot) => {
      const tempchems = [];
      querySnapshot.forEach((docu) => {
        tempchems.push({ ...docu.data(), key: docu.id });
      });
      setChemicals(tempchems);
    });

    const orchardRef = collection(db, "Orchards");
    const oq = query(orchardRef, orderBy("siteCode", "asc"));
    getDocs(oq).then((querySnapshot) => {
      const siteData = {};

      querySnapshot.forEach((docu) => {
        if (!docu.data().archive) {
          const { siteCode, blockName, blockCode, varietyCode, ...rest } = docu.data();

          if (!siteData[siteCode]) {
            siteData[siteCode] = {
              key: docu.id,
              siteName: docu.data().siteName,
              cropSureID: docu.data().cropSureID,
              orchardGUID: docu.data().orchardGUID,
              siteCode,
              ownerUIDs: Array.isArray(docu.data().ownerUIDs) ? docu.data().ownerUIDs : [],
              blocks: [],
            };
          } else if (!siteData[siteCode].orchardGUID && docu.data().orchardGUID) {
            siteData[siteCode].orchardGUID = docu.data().orchardGUID;
          }
          if (
            (!Array.isArray(siteData[siteCode].ownerUIDs) ||
              siteData[siteCode].ownerUIDs.length === 0) &&
            Array.isArray(docu.data().ownerUIDs)
          ) {
            siteData[siteCode].ownerUIDs = docu.data().ownerUIDs;
          }
          const block = siteData[siteCode].blocks.find((b) => b.blockName === blockName);

          if (!block) {
            siteData[siteCode].blocks.push({
              blockCode,
              cropSureBlockID: docu.data().cropSureBlockID,
              blockName: docu.data().blockName,
              blockActive: docu.data().blockActive,
              nupointBlockID: docu.data().nupointBlockID || "",
              varieties: [],
            });
          }

          const matchingBlock = siteData[siteCode].blocks.find((b) => b.blockName === blockName);

          if (matchingBlock) {
            if (!matchingBlock.nupointBlockID && docu.data().nupointBlockID) {
              matchingBlock.nupointBlockID = docu.data().nupointBlockID;
            }

            matchingBlock.varieties.push({
              key: docu.id,
              cropSureBlockVarietyID: docu.data().cropSureBlockVarietyID,
              varietyCode,
              ...rest,
            });
          }
        }
      });
      Object.values(siteData).forEach((site) => {
        site.blocks.sort((a, b) => a.blockName.localeCompare(b.blockName));
      });

      setOrchards(Object.values(siteData));
    });

    const employeeRef = collection(db, "Operators");
    const qe = query(employeeRef, orderBy("name", "asc"));
    getDocs(qe).then((querySnapshot) => {
      const tempemployees = [];
      querySnapshot.forEach((docu) => {
        if (!docu.data().archive) {
          tempemployees.push({ ...docu.data(), key: docu.id });
        }
      });
      setEmployees(tempemployees);
    });

    const varietiesRef = collection(db, "Varieties");
    const qv = query(varietiesRef, orderBy("varietyName", "asc"));
    getDocs(qv).then((querySnapshot) => {
      const tempvarieties = [];
      querySnapshot.forEach((docu) => {
        tempvarieties.push({ ...docu.data(), key: docu.id });
      });
      setVarieties(tempvarieties);
    });

    const sprayersRef = collection(db, "Tractors");
    const qs = query(sprayersRef, orderBy("sprayerName", "asc"));
    getDocs(qs).then((querySnapshot) => {
      const tempsprayers = [];
      querySnapshot.forEach((docu) => {
        if (!docu.data().archive) {
          tempsprayers.push({ ...docu.data(), key: docu.id });
        }
      });
      setSprayers(tempsprayers);
      setLoading(false);
    });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar absolute isMini />
      <MDBox mt={8}>
        {!loading && (
          <MDBox mb={3}>
            <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
              <Tab label="Chemicals" />
              <Tab label="Employees" />
              <Tab label="Sprayers" />
              <Tab label="Orchards" />
              <Tab label="Stocktake Mapping" />
            </Tabs>
            <MDBox mt={2}>
              {activeTab === 0 && <Chemicals chemicals={chemicals} />}
              {activeTab === 1 && <Employees employees={employees} />}
              {activeTab === 2 && <Sprayers sprayers={sprayers} />}
              {activeTab === 3 && <Orchards orchards={orchards} varieties={varieties} />}
              {activeTab === 4 && <StockLocations orchards={orchards} />}
            </MDBox>
          </MDBox>
        )}
        {loading && (
          <MDBox mb={3} textAlign="center">
            <CircularProgress />
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Setup;
